import React,{Component,Fragment} from 'react'
import styles from './index.module.scss'
import { observer, inject } from 'mobx-react'
import ChangeInfo from '../../components/ChangeInfo'
import environment from '../../lib/env.js'
import SDK from '../../sdk/utils'
@inject('tabBar')
@inject('userInfo')
@inject('weChat')
@observer
class Pagenormal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            phoneType:null,
            readArgument:false,
            isIpad:/ipad/i.test(navigator.userAgent.toLowerCase()) || /macintosh/.test(navigator.userAgent.toLowerCase()),
            payPrice:0,
            payType:'暂无类型',
            // leftd:'',
            lefth:'00',
            leftm:'00',
            lefts:'00',
        }
        // this.differBottom = this.differBottom.bind(this)
        this.handleClickPay = this.handleClickPay.bind(this)
        this.handleJump = this.handleJump.bind(this)
        this.handleChange = this.handleChange.bind(this);
        this.showtime = this.showtime.bind(this);
    }
    // ios android 续费协议区分
    // differBottom() {
    //     let result;
    //     // console.log(this.state.phoneType)
    //     if(this.state.phoneType === 'ios') {
    //         result = <div className={`${styles.blockArea} ${styles.declare}`}>
    //                     <div className={styles.title}>金山词霸会员自动续费商品声明：</div>
    //                     <div className={styles.wordItems}>
    //                         <span>1· </span>
    //                         <span>付款：会员产品您确定购买后，会从您的苹果iTunes 账户扣费；</span>
    //                     </div>
    //                     <div className={styles.wordItems}>
    //                         <span>2· </span>
    //                         <span>续费会员：您的会员到期前24小时，苹果会自动为您从iTunes账户扣费，成功后有效期自动延长一个周期；</span>
    //                     </div>
    //                     <div className={styles.wordItems}>
    //                         <span>3· </span>
    //                         <span>取消续费：若需要取消自动续费，请到期前至少24小时在“iOS-账户设置”关闭关闭后不再扣费；</span>
    //                     </div>
    //                 </div>
    //     } else {
    //         result = <div className={`${styles.blockArea} ${styles.declare}`}>
    //                     <div className={styles.title}>金山词霸会员自动续费商品声明：</div>
    //                     <div className={styles.wordItems}>
    //                         <span>1· </span>
    //                         <span>续费：您的会员到期前24小时，会为您自动续费，成功后有效期自动延长一个周期；</span>
    //                     </div>
    //                     <div className={styles.wordItems}>
    //                         <span>2· </span>
    //                         <span>取消续费：续费可以随时取消，若需要取消自动续费，请到期前至少24小时在“微信-我-钱包-支付管理-自动扣费”进行，取消后不再续费。</span>
    //                     </div>
    //                 </div>
    //     }
    //     return result;
    // }
    showtime() {
        setInterval(() => {
            var nowtime = new Date();  //获取当前时间
            var endtime = new Date(this.props.userInfo.vipInfo.year[0].activity_end_time && this.props.userInfo.vipInfo.year[0].activity_end_time.replace(/-/g, '/'));  //定义结束时间
            var lefttime = endtime.getTime() - nowtime.getTime(),  //距离结束时间的毫秒数
                // leftd = Math.floor(lefttime/(1000*60*60*24)),  //计算天数
                // lefth = Math.floor(lefttime/(1000*60*60)%24),  //计算小时数
                lefth = Math.floor(lefttime/(1000*60*60)),  //计算小时数
                leftm = Math.floor(lefttime/(1000*60)%60),  //计算分钟数
                lefts = Math.floor(lefttime/1000%60);  //计算秒数
                // leftd =  leftd >= 10 ? leftd : `0${leftd}`
                lefth = lefth >= 10 ? lefth : `0${lefth}`
                leftm = leftm  >= 10 ? leftm : `0${leftm}`
                lefts = lefts >= 10 ? lefts : `0${lefts}`
            this.setState(() => {
                return {lefth,leftm,lefts}
            })
        },1000)
    }
    isInActivity() {
        return this.state.phoneType !== 'ios' && this.props.userInfo.vipInfo.year[0].activity_flag == 1
    }
    // ios android 区分会员相关类别 与 付费参数区别
    differMemberType() {
        const vip_stat = this.props.userInfo.vipInfo.vip_stat;
        const click_flag = this.props.userInfo.vipInfo.year[0].click_flag;
        const isActivity = this.isInActivity();
        // 未登陆 售价 开通
        if(!this.props.userInfo.isLogin) {
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即开通</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>
                                </span>
                            </div>

                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>
                    </>
                )
            }
            return (
                <>
                    <div className={styles.payType}>立即开通</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>

                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
        // 登陆 非会员 开通
        else if(vip_stat == 0 && click_flag === 'buy') {
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即开通</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>

                                </span>
                            </div>
                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>
                    </>
                )
            }
            return (
                <>
                    <div className={styles.payType}>立即开通</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>

                            <b>/年</b>
                            {/* <span className={styles.originPrice}>
                                售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                            </span> */}
                        </div>
                        {/* <div className={styles.restTime}>
                            <span>限时折扣</span>
                            剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                        </div> */}
                    </div>
                </>
            )
        }
        // 登陆 普通会员 续费
        else if (vip_stat == 1 && click_flag === 'continue') {
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即续费</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>

                                </span>
                            </div>
                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>

                    </>
                )
            }
            return (
                <>
                    <div className={styles.payType}>立即续费</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>

                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
        // 登陆 书城会员 （旧版遗留，到期后没有这种会员，临时处理）
        else if (vip_stat == 2 && click_flag === 'continue') {
            // 普通会员 128<b>/年</b> 开通
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即开通</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>

                                </span>
                            </div>
                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>

                    </>
                )

            }
            return (
                <>
                    <div className={styles.payType}>立即开通</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>

                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
        // 登陆 荣耀会员 普通未开通
        else if (vip_stat == 4 && click_flag === 'buy') {
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即开通</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>
                                </span>
                            </div>
                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>
                    </>
                )
            }
            return (
                <>
                    <div className={styles.payType}>立即开通</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>
                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
        // 登陆 荣耀会员 普通续费
        else if (vip_stat == 4 && click_flag === 'continue') {
            // 普通会员 128<b>/年</b> 续费
            if(isActivity) {
                return (
                    <>
                        <div className={styles.payType}>立即续费</div>
                        <div className={styles.payPrice}>
                            <div className={styles.showPrice}>
                                <span>¥</span>
                                <span>{this.props.userInfo.vipInfo.year[0].activity_price}</span>
                                <b>/年</b>
                                <span className={styles.originPrice}>
                                    售价¥{this.props.userInfo.vipInfo.year[0].price}/年
                                    <div className={styles.line}></div>

                                </span>
                            </div>
                            <div className={styles.restTime}>
                                <span>限时折扣</span>
                                剩余{ this.state.lefth + ":" + this.state.leftm + ":" + this.state.lefts }
                            </div>
                        </div>
                    </>
                )
            }
            return (
                <>
                    <div className={styles.payType}>立即续费</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>
                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (
                <>
                    <div className={styles.payType}>立即开通</div>
                    <div className={styles.payPrice}>
                        <div className={styles.showPrice}>
                            <span>¥</span>
                            <span>{this.props.userInfo.vipInfo.year[0].price}</span>
                            <b>/年</b>
                        </div>
                    </div>
                </>
            )
        }
    }
    // 跳转页面
    handleJump (val) {
        if(environment.environment === 'wx') {
            val === 'member' ? window.location.href = 'https://my.iciba.com/vip/vip2/#/protocol-vip' : window.location.href = 'https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html'
        }
        let href;
        // 'https://my.iciba.com/vip/vip2/#/protocol-vip'
        val === 'member' ? href = 'https://my.iciba.com/vip/vip2/#/protocol-vip' : href = 'https://cdn.iciba.com/www/terms/iciba/mobile/privacy.html';
        SDK.toPage(
            `{"vc":"KSNormalWebViewController","urlString":"${href}","_statistic_flag":"vip-buy"}`,
            `{activity:com.kingsoft.MessageDetailActivity,url:'${href}'}`
        )
    }
    // 协议阅读
    handleChange(e) {
        e.target.checked ? this.setState(() =>({readArgument:true})) : this.setState(() => ({readArgument:false}))
    }
    // 微信公众号支付
    // wxhandlePay() {
    //     if(!this.state.readArgument) {
    //         this.props.tabBar.changeTabShow(true);
    //         this.props.tabBar.changeContant('请阅读并勾选协议')
    //     }
    //     console.log('判定环境')

    // }
    // 支付
    handleClickPay() {
        // 微信公众号
        // if(environment.environment === 'wx') {
        //     this.wxhandlePay();
        //     return false;
        // }
        // 安卓购买需要登陆 ios可以不登陆购买
        if(!this.props.userInfo.isLogin && this.state.phoneType !== 'ios') {
            SDK.autoLogin().then(res => {
                this.props.userInfo.refreshLoginState();
            })
            return false;
        }
        // 请先阅读协议
        if(!this.state.readArgument) {
            this.props.tabBar.changeTabShow(true);
            this.props.tabBar.changeContant('请阅读并勾选协议')
        }
        // 校验通过 支付
        else {
            const click_flag = this.props.userInfo.vipInfo.year[0].click_flag;
            // 埋点
            if(window.dw) window.dw.onEvent('cibaapp_vip_newvip_click', {client: SDK.isIos ? 'ios': 'android',click_type:click_flag == 'buy' ? 'common_buy' : 'common_renew'})
            let payData;
            // ios
            // ios如果存在月会员 先取消 才能购买2020版会员
            if(this.state.phoneType === 'ios') {
                console.log(this.props.userInfo.vipInfo.is_duration)
                if(this.props.userInfo.vipInfo.is_duration ==  1) {
                    this.props.tabBar.changeTabShow(true);
                    this.props.tabBar.changeContant('请先取消月会员自动续费，再购买年会员')
                    return false;
                }
                const iosInfo = this.props.userInfo.vipInfo.year_product_ids[0];
                payData = {
                    productId: iosInfo.product_id,
                    pay_good_id: iosInfo.goodId,
                    referenceName: iosInfo.name,
                    price:  iosInfo.price,
                    type: iosInfo.type,
                    good_type: iosInfo.good_type,
                    pay_type: 0,
                }
            } else {
                const androidInfo = this.props.userInfo.vipInfo.year[0]
                const useActPrice = this.isInActivity()
                payData = {
                    book_id: androidInfo.vip_type,
                    pay_good_id: androidInfo.goodId,
                    p_name: androidInfo.vip_name,
                    p_price:useActPrice ? androidInfo.activity_price : androidInfo.price,
                    // p_price: androidInfo.price,
                    p_desc: androidInfo.vip_detail,
                    type: androidInfo.vip_during_day,
                    bound: 0,
                    good_type: androidInfo.good_type,
                    pay_type:0
                }
            }
            let that = this;
            SDK.toPay(payData,function () {
                //  ios 且 没有微信 没弹窗
                // if(!that.props.userInfo.userInfo.installWechat && that.props.userInfo.phoneType === 'ios') {
                //     window.location.reload();
                // }
                if(that.props.userInfo.phoneType === 'ios') {
                    window.location.reload();
                } else {
                    that.props.userInfo.getVipStat();
                }
                // that.props.weChat.changeWeChatShow(true);
            })
        }
    }
    // 安卓ios区分（不再做区分 删除这个逻辑）
    // differPicTen() {
    //     // if (this.props.userInfo.phoneType === 'ios') {
    //         return (
    //             <img src={require('./images/10-ios-min.jpg')} alt=''/>
    //         )
    //     // } else {
    //     //     return (
    //     //         <img src={require('./images/10-android-min.jpg')} alt=''/>
    //     //     )
    //     // }
    // }
    // funca() {
    //     this.props.weChat.changeWeChatShow(true);
    // }
    componentWillMount() {
        this.setState(() => {
            return { phoneType:this.props.userInfo.phoneType }
        })
        this.showtime()
    }
    render() {
        return (
            <Fragment>
            <div>
                <div className={styles.blockArea}>
                    <img src={require('./images/1-min.png')} alt=''/>
                </div>
                <div className={styles.blockArea}>
                    <img src={require('./images/2-min.png')} alt=''/>
                </div>
                <div className={styles.blockArea}>
                    <img src={require('./images/3-min.png')} alt=''/>
                </div>

                {/* <div className={styles.blockArea}>
                    <img src={require('./images/4-min.jpg')} alt=''/>
                </div>
                <div className={styles.blockArea}>
                    <img src={require('./images/5-min.jpg')} alt=''/>
                </div>
                <div className={`${styles.blockArea} ${styles.scrollBorder}`}>
                    <img src={require('./images/6-min.jpg')} alt=''/>
                    <div className={`${styles.scrollX} ${styles.classone}`}>
                        <img src={require('./images/class1-min.png')} alt='' />
                    </div>
                </div>

                <div className={`${styles.blockArea} ${styles.scrollBorder}`}>
                    <img src={require('./images/7-min.jpg')} alt=''/>
                    <div className={`${styles.scrollX} ${styles.classtwo}`}>
                        <img src={require('./images/class2-min.png')} alt='' />
                    </div>
                    <div className={`${styles.scrollX} ${styles.classthree}`}>
                        <img src={require('./images/class3-min.png')} alt='' />
                    </div>
                </div>
                <div className={styles.blockArea}>
                    <img src={require('./images/8-min.jpg')} alt=''/>
                </div>
                <div className={`${styles.blockArea}`}>

                    <img src={require('./images/9-min.jpg')} alt=''/>
                </div> */}
                {/* 协议相关 */}
                <div className={`${styles.blockArea} ${styles.xyBlock} ${this.state.isIpad ? styles.ipadPadding : ''}`}>
                    <div className={styles.xyBlockContain}>
                        <div onClick={this.handleJump.bind(this,'member')} className={styles.button}>
                            <span>会员服务协议</span>
                            <img src={require('../../assets/icons/sj.svg')} alt=''/>
                        </div>
                        <div className={styles.line}></div>
                        <div onClick={this.handleJump.bind(this,'auto')} className={styles.button}>
                            <span>隐私协议</span>
                            <img src={require('../../assets/icons/sj.svg')} alt=''/>
                        </div>
                    </div>
                </div>
                {/* 续费声明 */}
                {/* {
                    this.differBottom()
                } */}
                <div className={`${styles.blockArea} ${styles.payBar}`}>
                    <div className={styles.argument}>
                        <div className={styles.checkboxBorder}>
                            <label>
                                <input
                                onChange={this.handleChange}
                                className={styles.checkbox} type='checkbox'/>
                            </label>
                        </div>
                        <div className={styles.word}>
                            我已阅读并同意<i onClick={this.handleJump.bind(this,'member')}>《会员服务协议》</i>和<i onClick={this.handleJump.bind(this,'auto')}>《隐私协议》</i>
                        </div>
                    </div>
                    {
                        this.differMemberType()
                    }
                    <img src={require('./images/normal.jpg')} alt=''/>
                    <div onClick={this.handleClickPay}className={styles.payIt}></div>
                </div>
            </div>
            </Fragment>
        )
    }
}
export default Pagenormal;